import axios, {AxiosResponse} from "axios";
import {LogisticBillLadingLoads} from "views/ProcessDetails/refactor/types/knowledges.types";

type PostContainersWebhookPayload = {
  data: string;
};

export const PostContainersWebhook = async (
  payload: PostContainersWebhookPayload,
): Promise<AxiosResponse<LogisticBillLadingLoads[]>> => {
  const webhookUrl = import.meta.env.VITE_N8N_CONTAINERS_WEBHOOK;

  if (!webhookUrl) {
    throw new Error("VITE_N8N_CONTAINERS_WEBHOOK não está configurada.");
    //teste
  }

  return await axios.post<LogisticBillLadingLoads[]>(webhookUrl, payload, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
